import { Component } from '@angular/core';

@Component({
  selector: 'kbxl-color-bar',
  templateUrl: './color-bar.component.html',
  styleUrls: ['./color-bar.component.scss'],
})
export class ColorBarComponent {}
